export default [{ name: 'name', label: 'Name', component: 'input' }];
